import { render, staticRenderFns } from "./ByMemory.vue?vue&type=template&id=f8e82f0a&scoped=true"
import script from "./ByMemory.vue?vue&type=script&lang=js"
export * from "./ByMemory.vue?vue&type=script&lang=js"
import style0 from "./ByMemory.vue?vue&type=style&index=0&id=f8e82f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e82f0a",
  null
  
)

export default component.exports